module.exports = __webpack_public_path__ + "fonts/opensans-bolditalic-webfont.6f90dd9.woff2";